
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30.363","height":"31.741"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0v31.741h26.221v-13.2l3.038-3.019a.777.777 0 00.143-.213l.132-.132a2.822 2.822 0 00-3.313-4.493V0zm1.38 1.38h23.461v10.625l-4.555 4.555H9.66v1.38h9.248l-2.76 2.76H9.66v1.38h5.108l-.278.278c-.137.067-.208.137-.208.275l-1.173 4.14a.659.659 0 00.623.895h.2l4.14-1.1c.07-.07.208-.137.275-.208l6.488-6.445v10.446H1.38zm3.45 6.9v1.38h2.76V8.28zm4.83 0v1.38h11.73V8.28zm-4.83 4.14v1.38h2.76v-1.38zm4.83 0v1.38h11.73v-1.38zm16.42.275l2.038 2.035-10.59 10.523-.011.005-2.017-1.972.027-.1zM4.83 16.561v1.38h2.76v-1.38zm0 4.14v1.38h2.76V20.7z","fill":"#fff"}})])
          )
        }
      }
    